const addDates = (...dates) => dates.map((date) => {
  if (date instanceof Date)
    return date.getTime();
  if (typeof date === "string")
    return new Date(date).getTime();
  if (typeof date === "number")
    return date;
  if (typeof date === "object") {
    const { hours = 0, minutes = 0 } = date;
    return hours * 60 * 60 * 1e3 + minutes * 60 * 1e3;
  }
  return 0;
}).reduce((date, ms = 0) => {
  return new Date(new Date(date).getTime() + ms);
}, new Date(0));
var addDates_default = addDates;
export {
  addDates_default as default
};
